<template>
  <aside
    class="bg-white border-b border-gray-300 flex w-full transition-all duration-300 ease-in-out overflow-hidden h-16 px-6"
  >
    <div
      class="flex items-center justify-between self-center flex-shrink-0"
    >
      <div
        class="flex items-center  hover:rounded-lg cursor-pointer p-2 relative"
      >
        <img
          v-if="workSpace?.logo"
          :src="workSpace.logo"
          :alt="workSpace.name"
          class="w-14 h-14  object-contain rounded-lg"
        >
        <div
          v-else
          class="font-bold text-lg text-gray-900"
        >
          {{ workSpace?.name }}
        </div>
      </div>
    </div>

    <div class="flex items-center w-full justify-end">
      <Button
        type="button"
        icon="pi pi-ellipsis-v"
        aria-haspopup="true"
        aria-controls="overlay_menu"
        severity="secondary"
        @click="toggleHamburgerMenu"
      />

      <Menu
        id="overlay_menu"
        ref="hamburgerMenuRef"
        :model="items"
        :popup="true"
        :pt="{
          root: {
            class: 'w-full',
          },
        }"
      >
        <template #item="{ item, props }">
          <router-link
            v-if="item.route"
            v-slot="{ href, navigate }"
            :to="item.route"
            custom
          >
            <a
              v-ripple
              :href="href"
              v-bind="props.action"
              @click="navigate"
            >
              <Icon
                :name="item.icon || ''"
                class="w-4"
              />
              <span>{{ item.label }}</span>
            </a>
          </router-link>

          <div v-else-if="item.label === 'Logout'">
            <SignOutButton :redirect-url="`${authAppUrl}/auth/sign-in`">
              <button
                class="flex items-center space-x-2 p-2 cursor-pointer"
                @click="handleMenuItemClick(item)"
              >
                <Icon
                  :name="item.icon || ''"
                  class="w-4 ml-1"
                />
                <span class="font-sans">{{ item.label }}</span>
              </button>
            </SignOutButton>
          </div>

          <a
            v-else
            v-ripple
            :href="item.url"
            :target="item.target"
            v-bind="props.action"
          >
            <span :class="item.icon" />
            <span>{{ item.label }}</span>
          </a>
        </template>
      </Menu>
    </div>
  </aside>
</template>

<script setup lang="ts">
import { SidebarIcon } from '~/types/baseIcon'

// Hamburger Menu
const hamburgerMenuRef = ref()
const items = ref([
  {
    label: 'Businesses',
    icon: SidebarIcon.BUSINESS,
    route: '/businesses',
  },
  {
    label: 'Pipeline',
    icon: SidebarIcon.PIPELINE,
    route: '/pipeline',
  },
  {
    label: 'Logout',
    icon: 'lucide:log-out',
    command: () => {},
  },
])

const toggleHamburgerMenu = (event) => {
  hamburgerMenuRef.value.toggle(event)
}

const {
  workSpace,
  handleMenuItemClick,
} = useSidebar()

const authAppUrl = process.env.AUTH_APP_URL || 'https://auth.cimpro.app'
</script>
